"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetFieldValuesMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetFieldValuesMethod");
var IFilterClause_1 = require("@tableau/vizportal-webclient-api/lib/api/types/IFilterClause");
var Localize_1 = require("../../gen-src/Localize");
var FilterPanel_1 = require("../components/FilterPanel/FilterPanel");
var ConnectToDatabasesTotalCountQueryGql_1 = require("../queries/ConnectToDatabasesTotalCountQueryGql");
var ConnectToTablesTotalCountQueryGql_1 = require("../queries/ConnectToTablesTotalCountQueryGql");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var ConnectToDialogFunctions_1 = require("./ConnectToDialogFunctions");
exports.filterPrefix = 'connect-to-dialog-';
exports.connectionTypeFilterName = 'connection-type-filter';
exports.dataQualityWarningFilterName = 'data-quality-warning-filter';
exports.certifiedFilterName = 'certified-filter';
exports.hasDataQualityWarningvalue = 'has-warnings';
exports.doesNotHaveDataQualityWarningValue = 'does-not-have-warnings';
exports.defaultSelectionValue = 'any-status';
exports.visibleFiltersByDataType = getDataTypesToFilterNames();
function getDataTypesToFilterNames() {
    var result = new Map();
    result.set('Datasources', [[exports.connectionTypeFilterName, exports.certifiedFilterName]]);
    result.set('Databases', [[exports.dataQualityWarningFilterName, exports.certifiedFilterName]]);
    result.set('Tables', [[exports.dataQualityWarningFilterName, exports.certifiedFilterName]]);
    result.set('NoSelection', [[]]);
    return result;
}
exports.intitialConnectToDialogFilterPanelState = {
    connectionTypeState: exports.defaultSelectionValue,
    certifiedState: false,
    dataQualityWarningState: exports.defaultSelectionValue,
    filterPanelIsDisplayed: false,
    filtersApplied: false,
    querySearchText: '',
    visibleFilterNames: exports.visibleFiltersByDataType.get('NoSelection')
};
function connectionTypeFilterVariableValue(filterStates) {
    switch (filterStates.connectionTypeState) {
        case exports.defaultSelectionValue:
        case undefined:
            return null;
        default:
            return filterStates.connectionTypeState;
    }
}
exports.connectionTypeFilterVariableValue = connectionTypeFilterVariableValue;
function createSelectionFilter(testIdSuffix, getAvailableSelections, getDisplayValue, locallyFilteringList, label, value) {
    return {
        getAvailableSelections: getAvailableSelections,
        getDisplayValue: getDisplayValue,
        locallyFilteringList: locallyFilteringList,
        label: label,
        testId: exports.filterPrefix + testIdSuffix,
        type: 'Selection',
        textValue: value
    };
}
exports.createSelectionFilter = createSelectionFilter;
function createBooleanFilter(testIdSuffix, label, value) {
    return {
        label: label,
        testId: exports.filterPrefix + testIdSuffix,
        type: 'Boolean',
        booleanValue: value
    };
}
exports.createBooleanFilter = createBooleanFilter;
function getDisplayValueFromItems(value, items) {
    if (!items) {
        return value;
    }
    var item = items.find(function (li) { return li.value === value; });
    return (item && item.displayValueWhenSelected) ? item.displayValueWhenSelected : value;
}
exports.getDisplayValueFromItems = getDisplayValueFromItems;
function anyFilterApplied(state) {
    return !!state.certifiedState
        || !!state.connectionTypeState && state.connectionTypeState !== exports.defaultSelectionValue
        || !!state.dataQualityWarningState && state.dataQualityWarningState !== exports.defaultSelectionValue;
}
exports.anyFilterApplied = anyFilterApplied;
function getConnectionTypeFilterValue(filterStates) {
    var currentState = filterStates.connectionTypeState;
    return currentState !== exports.defaultSelectionValue ? currentState : null;
}
exports.getConnectionTypeFilterValue = getConnectionTypeFilterValue;
function getCertifiedFilterValue(filterStates) {
    // we only populate the certified filter query variables when the certified filter checkmark is checked.
    // i.e. we don't want to filter by 'not-certified' when the checkmark is unchecked.
    if (filterStates.certifiedState) {
        return true;
    }
    else {
        return null;
    }
}
exports.getCertifiedFilterValue = getCertifiedFilterValue;
function getDataQualitWarningFilterValue(filterStates) {
    // data quality warning is a selection filter and therefore we filter by its value whether its true or false.
    switch (filterStates.dataQualityWarningState) {
        case exports.hasDataQualityWarningvalue:
            return true;
        case exports.doesNotHaveDataQualityWarningValue:
            return false;
        case exports.defaultSelectionValue:
        default:
            return null;
    }
}
exports.getDataQualitWarningFilterValue = getDataQualitWarningFilterValue;
function appendPreviousSelectionIfApplicable(previousItems, currentItems, currentValue) {
    // if we had a non-default type previously selected and the updated options don't
    // contain that selection, we still show the selection with 0 count.
    if (previousItems && currentValue !== exports.defaultSelectionValue && !currentItems.find(function (li) { return li.value === currentValue; })) {
        var currentItem = previousItems.find(function (li) { return currentValue === li.value; });
        if (currentItem) {
            currentItems.push(__assign({}, currentItem, { content: FilterPanel_1.createSelectionFilterListItemContent(currentItem.displayValueWhenSelected, 0), count: 0 }));
        }
    }
}
exports.appendPreviousSelectionIfApplicable = appendPreviousSelectionIfApplicable;
function getAvailableConnectionTypesAndCounts(dataType, filterStates, vizPortalWebClientRequester) {
    return __awaiter(this, void 0, void 0, function () {
        var availableConnectionTypeFilterOptions, isCertifiedFilterValue, _a, getFieldValues, clauses, filter, params, result;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    availableConnectionTypeFilterOptions = [];
                    isCertifiedFilterValue = filterStates.certifiedState ? filterStates.certifiedState : null;
                    _a = dataType;
                    switch (_a) {
                        case 'Datasources': return [3 /*break*/, 1];
                        case 'Databases': return [3 /*break*/, 3];
                        case 'Tables': return [3 /*break*/, 3];
                        case 'NoSelection': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 4];
                case 1:
                    getFieldValues = vizPortalWebClientRequester.createSender(GetFieldValuesMethod_1.GetFieldValuesMethod);
                    clauses = [
                        vizportal_webclient_api_1.Filter.search(filterStates.querySearchText),
                        vizportal_webclient_api_1.Filter.fieldEq(IFilterClause_1.FilterFieldNames.isPublished, true)
                    ];
                    if (isCertifiedFilterValue) {
                        clauses.push(vizportal_webclient_api_1.Filter.fieldEq('isCertified', isCertifiedFilterValue)); // todo add literal to FilterFieldNames
                    }
                    filter = {
                        clauses: clauses,
                        operator: IFilterClause_1.FilterOps.and
                    };
                    params = {
                        field: IFilterClause_1.FilterFieldNames.connectionType,
                        labelMatchText: '',
                        page: {
                            startIndex: 0,
                            maxItems: 1000
                        },
                        resourceCountFilter: filter,
                        resourceType: 'datasource',
                    };
                    return [4 /*yield*/, getFieldValues(params)];
                case 2:
                    result = _b.sent();
                    if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(result) && ConnectToDialogFunctions_1.isIGetFieldValuesResult(result.response.result)) {
                        result.response.result.fieldValues.forEach(function (fv) {
                            availableConnectionTypeFilterOptions.push({
                                content: FilterPanel_1.createSelectionFilterListItemContent(fv.label, fv.count),
                                count: fv.count,
                                displayValueWhenSelected: fv.label,
                                value: fv.value
                            });
                        });
                    }
                    return [3 /*break*/, 5];
                case 3: return [3 /*break*/, 5];
                case 4:
                    TypescriptHelpers_1.assertUnreachable(dataType);
                    _b.label = 5;
                case 5:
                    appendPreviousSelectionIfApplicable(filterStates.availableConnectionTypeFilterOptions, availableConnectionTypeFilterOptions, filterStates.connectionTypeState);
                    return [2 /*return*/, availableConnectionTypeFilterOptions];
            }
        });
    });
}
exports.getAvailableConnectionTypesAndCounts = getAvailableConnectionTypesAndCounts;
function getAvailableDataQualityWarningSelections(catalogClient, dataType, filterStates) {
    return __awaiter(this, void 0, void 0, function () {
        var filterPanelDQWSelections, isCertifiedFilterValue, _a, countWithWarnings, countWithoutWarnings, countWithWarnings, countWithoutWarnings;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    filterPanelDQWSelections = [];
                    isCertifiedFilterValue = !!filterStates.certifiedState ? filterStates.certifiedState : null;
                    _a = dataType;
                    switch (_a) {
                        case 'Databases': return [3 /*break*/, 1];
                        case 'Tables': return [3 /*break*/, 4];
                        case 'Datasources': return [3 /*break*/, 7];
                        case 'NoSelection': return [3 /*break*/, 7];
                    }
                    return [3 /*break*/, 8];
                case 1: return [4 /*yield*/, catalogClient.query({
                        query: ConnectToDatabasesTotalCountQueryGql_1.ConnectToDatabasesTotalCountQueryGql,
                        variables: {
                            databaseFilterText: filterStates.querySearchText,
                            hasActiveWarningFilter: true,
                            isCertifiedFilter: isCertifiedFilterValue
                        }
                    })];
                case 2:
                    countWithWarnings = (_b.sent()).data.databasesConnection.totalCount;
                    return [4 /*yield*/, catalogClient.query({
                            query: ConnectToDatabasesTotalCountQueryGql_1.ConnectToDatabasesTotalCountQueryGql,
                            variables: {
                                databaseFilterText: filterStates.querySearchText,
                                hasActiveWarningFilter: false,
                                isCertifiedFilter: isCertifiedFilterValue
                            }
                        })];
                case 3:
                    countWithoutWarnings = (_b.sent()).data.databasesConnection.totalCount;
                    filterPanelDQWSelections.push({
                        content: FilterPanel_1.createSelectionFilterListItemContent(Localize_1.Messages.DataQualityWarningFilterOffSelection(), countWithoutWarnings),
                        count: countWithoutWarnings,
                        displayValueWhenSelected: Localize_1.Messages.DataQualityWarningFilterOffSelection(),
                        value: exports.doesNotHaveDataQualityWarningValue
                    });
                    filterPanelDQWSelections.push({
                        content: FilterPanel_1.createSelectionFilterListItemContent(Localize_1.Messages.DataQualityWarningFilterOnSelection(), countWithWarnings),
                        count: countWithWarnings,
                        displayValueWhenSelected: Localize_1.Messages.DataQualityWarningFilterOnSelection(),
                        value: exports.hasDataQualityWarningvalue
                    });
                    return [3 /*break*/, 9];
                case 4: return [4 /*yield*/, catalogClient.query({
                        query: ConnectToTablesTotalCountQueryGql_1.ConnectToTablesTotalCountQueryGql,
                        variables: {
                            tableFilterText: filterStates.querySearchText,
                            isCertifiedFilter: isCertifiedFilterValue,
                            hasActiveWarningFilter: true
                        }
                    })];
                case 5:
                    countWithWarnings = (_b.sent()).data.databaseTablesConnection.totalCount;
                    return [4 /*yield*/, catalogClient.query({
                            query: ConnectToTablesTotalCountQueryGql_1.ConnectToTablesTotalCountQueryGql,
                            variables: {
                                tableFilterText: filterStates.querySearchText,
                                isCertifiedFilter: isCertifiedFilterValue,
                                hasActiveWarningFilter: false
                            }
                        })];
                case 6:
                    countWithoutWarnings = (_b.sent()).data.databaseTablesConnection.totalCount;
                    filterPanelDQWSelections.push({
                        content: FilterPanel_1.createSelectionFilterListItemContent(Localize_1.Messages.DataQualityWarningFilterOffSelection(), countWithoutWarnings),
                        count: countWithoutWarnings,
                        displayValueWhenSelected: Localize_1.Messages.DataQualityWarningFilterOffSelection(),
                        value: exports.doesNotHaveDataQualityWarningValue
                    });
                    filterPanelDQWSelections.push({
                        content: FilterPanel_1.createSelectionFilterListItemContent(Localize_1.Messages.DataQualityWarningFilterOnSelection(), countWithWarnings),
                        count: countWithWarnings,
                        displayValueWhenSelected: Localize_1.Messages.DataQualityWarningFilterOnSelection(),
                        value: exports.hasDataQualityWarningvalue
                    });
                    return [3 /*break*/, 9];
                case 7: return [3 /*break*/, 9];
                case 8:
                    TypescriptHelpers_1.assertUnreachable(dataType);
                    _b.label = 9;
                case 9:
                    appendPreviousSelectionIfApplicable(filterStates.availableDataQualityWarningFilterOptions, filterPanelDQWSelections, filterStates.dataQualityWarningState);
                    return [2 /*return*/, filterPanelDQWSelections];
            }
        });
    });
}
exports.getAvailableDataQualityWarningSelections = getAvailableDataQualityWarningSelections;
//# sourceMappingURL=ConnectToDialogFilterPanel.js.map